import PropTypes from 'prop-types';

function MMShopByInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M11.203 15.2622L9.76794 12.9551L26.5845 15.2916L28.0195 17.5988L11.203 15.2622Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.0209 17.5995L11.2047 15.2617L8.86693 32.0779L25.6831 34.4157L28.0209 17.5995Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M34.1937 18.4571L28.0182 17.5986L25.6805 34.4148L31.8559 35.2733L34.1937 18.4571Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M35.6861 22.8779L29.5102 22.019L28.0195 17.5986L34.1925 18.4573L35.6861 22.8779Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.4901 11.5983C24.6054 10.4728 24.7984 7.96297 24.7984 7.96297"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M30.1053 13.5239C30.6282 12.9947 31.7373 11.7803 31.7373 11.7803"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.7603 10.9561C17.5029 10.2508 16.8724 8.70117 16.8724 8.70117"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default MMShopByInactive;

MMShopByInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MMShopByInactive.defaultProps = {
    className: null,
    width: 28,
};
